import * as React from 'react';
import * as m from 'motion/react-m';
import { Alert, AlertProps } from 'components/feedback/Alert';

type SnackbarProps = {
  readonly duration: number; // ms
  readonly onClick: () => unknown;
} & Omit<AlertProps, 'onClose'>;

function Snackbar({ duration, onClick, ...alertProps }: SnackbarProps) {
  const onCloseRef = React.useRef(onClick);
  React.useEffect(() => {
    onCloseRef.current = onClick;
  });

  React.useEffect(() => {
    const timeout = setTimeout(() => onCloseRef.current(), duration);
    return () => clearTimeout(timeout);
  }, [duration]);

  return (
    <m.div
      layout
      initial={{ opacity: 0, x: 48, scale: 0.96 }}
      animate={{ opacity: 1, x: 0, scale: 1 }}
      exit={{ opacity: 0, x: 48, scale: 0.96 }}
      transition={{ duration: 0.25, ease: [0.4, 0, 0.2, 1] }}
      onClick={onClick}
      className="pointer-events-auto relative w-[32rem] max-w-full cursor-pointer overflow-hidden rounded-lg shadow-[0_10px_30px_-12px_rgb(40_61_91_/_50%)] max-md:w-full"
      style={{ '--snackbar-duration': `${duration}ms` } as React.CSSProperties}
    >
      <Alert onClose={onClick} {...alertProps} />
      <span className="absolute bottom-0 left-0 h-[3px] w-full origin-left animate-[snackbar-progress_var(--snackbar-duration,5000ms)_linear_forwards] bg-[rgb(255_255_255_/_55%)]" />
    </m.div>
  );
}

export { Snackbar };
